import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { buildTime, seed } from '#event-config'
import App from './App'
import './index.css'

/*
 * Title and theme colour come from the same config the prices do, so a new event
 * does not need anyone to remember to edit index.html as well.
 */
document.title = `${seed.title} — จ่ายครบ`
document.querySelector('meta[name="theme-color"]')?.setAttribute('content', buildTime.primaryColor)

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
